import { Badge } from '@nesso/ui/primitives/badge';
import { Switch } from '@nesso/ui/primitives/switch';

import { SettingsRow } from '@/shared/ui/settings/settings-row';
import { SettingsSection } from '@/widgets/settings/settings-section';

export function BillingAutomationSection() {
    return (
        <SettingsSection
            title="Billing automation"
            badge={<Badge variant="secondarySoft">Coming Soon</Badge>}
        >
            <SettingsRow
                label="Autopay"
                caption="When enabled, we will attempt to charge your client’s balance overnight each night"
                className="opacity-50"
                trailing={
                    <Switch
                        checked={false}
                        disabled
                        // The row is already dimmed; this stops the disabled switch dimming twice.
                        className="disabled:opacity-100"
                        aria-label="Autopay"
                    />
                }
            />
        </SettingsSection>
    );
}
